import React from 'react';
import PropTypes from 'prop-types';
import { InfoFilled } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';

export const StoreOnlyAlert = () => {
  return (
    <>
      <div className="sui-pt-4">
        <div className="sui-flex">
          <span className="sui-mt-1">
            <InfoFilled size="regular" style={{ color: '#499992' }} />
          </span>
          <Typography variant="body-base" component="div">
            <div className="sui-pl-2">
              <span>This item isn&apos;t available for Pickup online, but can still be purchased in-store.</span>
            </div>
          </Typography>
        </div>
      </div>
    </>
  );
};
